import { useCallback, useEffect, useState } from "react";
import { apiRequest } from "@/helper/api";
import type {
  GlobalSettingKey,
  GlobalSettings,
} from "@/components/globalSettings/globalSettingDefinitions";

const SETTINGS_ENTITY = "settings";

export function useGlobalSettings(onLoadError: (error: unknown) => void) {
  const [settings, setSettings] = useState<GlobalSettings | null>(null);

  useEffect(() => {
    let isMounted = true;

    apiRequest<GlobalSettings>({
      entity: SETTINGS_ENTITY,
      method: "get",
      shouldNotImpersonate: true,
    })
      .then((response) => {
        if (isMounted) {
          setSettings(response.data);
        }
      })
      .catch((error) => {
        if (isMounted) {
          onLoadError(error);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []); 

  const saveSetting = useCallback(
    async (key: GlobalSettingKey, value: string | null) => {
      const response = await apiRequest<GlobalSettings>({
        entity: SETTINGS_ENTITY,
        method: "put",
        submitData: { [key]: value },
        shouldNotImpersonate: true,
      });
      setSettings(response.data);
    },
    [],
  );

  return { settings, saveSetting };
}
